<i18n>
{
	"en": {
		"hasNoContent": "Found nothing here"
	},
	"no": {
		"hasNoContent": "Fant ikke noe her"
	}
}
</i18n>

<template>
	<div
		class="multiple-text-areas"
		:class="{ hasContent: Boolean(textAreas.length) }"
	>
		<div class="container">

			<template v-if="textAreas.length">

				<template v-for="({ key, name, value }, index) in textAreas">

					<div
						:key="key"
						class="freetext-container"
					>
						<t-text-area
							:key="key"
							class="freetext-area"
							style="width: 220px;"
							:disabled="disabled"
							:label="name"
							minHeight="65px"
							height="65px"
							:autoFocus="key === textAreaKeyToFocus"
							resize="vertical"
							:textAreaMaxHeight="textAreaMaxHeight"
							:value="value"
							@input="$emit('textAreaInput', {key, value: $event, index})"
							@change="$emit('textAreaChange', {key, value: $event, index})"
						/>
					</div>

				</template>
			</template>

			<template v-else>
				<p style="margin: 12px 16px">{{ noContentString ? noContentString : $t('hasNoContent') }}</p>
			</template>
		</div>

	</div>
</template>

<script>
export default {
	name: 'MultipleTextAreas',
	props: {
		textAreas: {
			type: Array,
			required: true,
			validator: value => value.every(

				textArea => ('key' in textArea) && ('value' in textArea) && ('name' in textArea)
			)
		},
		disabled: {
			type: Boolean,
			default: false
		},
		textAreaKeyToFocus: {
			type: String,
			required: false
		},
		textAreaMaxHeight: {
			type: String,
			default: '300px'
		},
		noContentString: {
			type: String,
			required: false
		}
	}
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';

.multiple-text-areas {
	height: 100%;
	overflow-x: auto;
	background-color: get-color($background, 'tint1');
}

.multiple-text-areas.hasContent {
	background: white;
}

.container {
	height: 230px; // TODO matiaseid dont hardcode this

	display: inline-flex;
	flex-flow: column wrap;
}

.freetext-container {
	width: 220px;

	padding: 4px 12px 0 12px;
	margin: 4px 0px 4px 0px;
}

</style>
